import React from 'react';
import { Skeleton } from 'antd';

export default () => {
  return (
    <>
      <Skeleton active />
    </>
  );
};
